import Vue from "vue";
import Router from "vue-router";
import { routes } from "./routes";
import { store } from "../store";
Vue.use(Router);

function createRouterInstance(baseurl) {

  return new Router({
    routes,
    base: baseurl,
    mode: "history",
    scrollBehaviour(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition;
      }
      if (to.hash) {
        return {
          selector: to.hash
        };
      }
    }
  });
}

let customRouter = createRouterInstance(process.env.VUE_APP_BASE_URL);

customRouter.beforeEach(async (to, from, next) => {
  

  const isLoggedOut = !store.state.auth0.auth0.isLoggedIn && localStorage.getItem('isLoggedIn') !== 'true';

  // If the user is logged out and trying to access a protected route, redirect to login
  if (isLoggedOut && to.meta.auth) {
    next('/auth/login');
    return;
  }
  if (to.name === 'CallFlow') {
    
    let CALL_FLOW_URL=JSON.parse(localStorage.getItem("logodetails")).callflow_domain
    if(CALL_FLOW_URL!== null && CALL_FLOW_URL !== ""){
      CALL_FLOW_URL = `https://${CALL_FLOW_URL}`;
    }else {
      CALL_FLOW_URL = "";
    }
  
      window.open(CALL_FLOW_URL, '_blank');
      next(false);
      return;
    
  }

  if (top.location != self.location) {
    top.location = '/error-page';
    return;
  }


  const url = new URL(window.location.href);
  const token = url.searchParams.get('token');
  

  const isAuthenticated = store.state.auth0.auth0.isLoggedIn || localStorage.getItem('isLoggedIn') === 'true';
  // const isAdminRoute = to.matched.some(record => record.meta.auth);
  // const lastAdminRoute = sessionStorage.getItem('lastAdminRoute');

  // Auto-login logic
  if (to.name === 'doocti/Auth/Login' && to.query.token) {
    const loginDataParam = to.query.token;
    
    if (token) {
      localStorage.setItem('loginInitiated', 'true');
      
      try {
        await store.dispatch('initiateAutoLogin', loginDataParam);
        localStorage.setItem("socketConnectCount", 0);
        localStorage.setItem('isLoggedIn', 'true');
        next({ name: 'realtime/LiveAgents' });
        return;
      } catch (error) {
        console.error('Auto-login failed:', error);
        localStorage.removeItem('loginInitiated');
        sessionStorage.removeItem('isLoggedIn');
        next('/auth/login');
        return;
      }
    } else {
      console.log('Auto-login already initiated, proceeding with navigation');
    }
  }

  // Authentication and permission check
  if (to.meta.auth) {
    console.log('Checking user permissions');
    let filtered = store.getters.UserPermissions.filter(permission => {
      return (to.meta.permission.access.indexOf(permission) !== -1);
    });
    console.log(`Filtered permissions: ${filtered.length}`);
    
    if (filtered.length > 0) {
      console.log(store.state.auth0.auth0.isLoggedIn,'User has required permissions, allowing navigation');
      // Store the current admin route
      sessionStorage.setItem('lastAdminRoute', to.fullPath);
      next();
    } else if (isAuthenticated) {
      console.log("User logged in but lacks permission, redirecting to blank page");
      next('/blank-page');
    } else {
      console.log("User not logged in, redirecting to login page");
      localStorage.clear();
      sessionStorage.clear();
      next('/auth/login');
    }
  } else {
    console.log('No authentication required for this route');

    next();
  }
});

export default customRouter;